import { app } from '../../app.module'
/**
 * トレンドワードのタイプを選択するフォーム。タイプを選択した場合、イベントを送信する
 */
class TrendWordTypeFormComponentCtrl {
  private scope: ng.IScope
  private label: string
  private types: {}[]

  constructor($scope) {
    this.scope = $scope
    this.label = 'タイプ'
    this.types = [
      {
        value: null,
        name: '指定しない',
      },
      {
        value: 'keyword',
        name: 'キーワード',
      },
      {
        value: 'hashtag',
        name: 'ハッシュタグ',
      },
    ]
  }

  /**
   * 選択した順位をイベント送信する
   * @param  {string} selectedRank
   */
  public selectType(seletectedType: string) {
    if (seletectedType === '') {
      seletectedType = null
    }

    // イベントをemitする
    this.scope.$emit('changeFilterData', {
      type: 'trendword-type',
      value: seletectedType,
    })
  }
}

app.component('trendwordTypeForm', {
  template: require('./trendword-type-form.pug')(),
  controller: TrendWordTypeFormComponentCtrl,
})
